module.exports = __webpack_public_path__ + "static/full06-7cd7ee5c296ee8ccf1503f8d7a2210c1.png";